import React, { useEffect } from 'react';
import { IItemForGetShortInfo, IGetModifierGroupsShortResponse, IGetModifierGroupsShort, ITotalPrice } from 'types';
import { useFetchData } from 'hooks/useFetchData';
import { getModifierGroupsShortInfo } from 'backend/modifierGroups';
import MultipleSelect from './components/MultipleSelect';
import style from './ModifierGroupsMultipleSelect.module.scss';

interface IModifierGroupsMultipleSelect {
	setFetchedModifierGroups: (value: IItemForGetShortInfo[]) => void;
	setModifierGroups: (value: string[]) => void;
	selectedModifierGroups: string[];
	totalPrices: ITotalPrice[];
}

const ModifierGroupsMultipleSelect: React.FC<IModifierGroupsMultipleSelect> = ({
	selectedModifierGroups,
	totalPrices,
	setFetchedModifierGroups,
	setModifierGroups,
}) => {
	const { response, loading, refetch, responseError } = useFetchData<
		IGetModifierGroupsShortResponse,
		IGetModifierGroupsShort
	>(totalPrices.length ? getModifierGroupsShortInfo : null, {
		restaurantIds: totalPrices.map((el) => el.restaurantId),
	});

	useEffect(() => {
		refetch();
	}, [totalPrices]);

	useEffect(() => {
		if (response) {
			setFetchedModifierGroups(response.data.modifierGroups);
		}
	}, [response]);

	return (
		<div className={style.container}>
			<div className={style.field}>
				<MultipleSelect
					data={response?.data.modifierGroups || []}
					isLoading={loading}
					refetch={refetch}
					responseError={responseError}
					totalPrices={totalPrices}
					selectedModifierGroups={selectedModifierGroups}
					setModifierGroups={setModifierGroups}
				/>
			</div>
		</div>
	);
};

export default React.memo(ModifierGroupsMultipleSelect);
